import constants from "../consts/constants";
import axios from 'axios'

class Api {
    constructor ({serverUrl}) {
        this._serverUrl = serverUrl
    }

    async LoadUser(initDataUnsafe) {
        const res = await axios.post(`${this._serverUrl}/loaduser`, {initDataUnsafe: initDataUnsafe})
        return {res: res.data, status: res.status}
    }

    async LoadEvents() {
        const res = await axios.get(`${this._serverUrl}/loadevents`)
        return {res: res.data, status: res.status}
    }

    async AddMember(eventData, memberData) {
        const res = await axios.post(`${this._serverUrl}/addmember`, {eventData: eventData, memberData: memberData})
        return {res: res.data, status: res.status}
    }

    async CancelMembership(eventData, memberData) {
        const res = await axios.post(`${this._serverUrl}/cancelmembership`, {eventData: eventData, memberData: memberData})
        return {res: res.data, status: res.status}
    }

    async DeleteUser(initDataUnsafe) {
        const res = await axios.post(`${this._serverUrl}/deleteuser`, {initDataUnsafe: initDataUnsafe})
        return {res: res.data, status: res.status}
    }

    async SignUp(initDataUnsafe, userData) {
        const res = await axios.post(`${this._serverUrl}/signup`, {initDataUnsafe: initDataUnsafe, userData: userData})
        return {res: res.data, status: res.status}
    }
}

const API = new Api({
    serverUrl: constants.serverUrl
})

export default API